import { useCallback } from "react";
import { useSearchParams } from "react-router";

export function usePhotosDrivingDay(): [
  string | null,
  (day: string | null) => void,
] {
  const [searchParams, setSearchParams] = useSearchParams();

  const photosDrivingDay = searchParams.get("photosDrivingDay");
  const setPhotosDrivingDay = useCallback(
    (day: string | null): void => {
      setSearchParams((params) => {
        if (day === null) {
          params.delete("photosDrivingDay");
        } else {
          params.set("photosDrivingDay", day);
        }
        return params;
      });
    },
    [setSearchParams],
  );
  return [photosDrivingDay, setPhotosDrivingDay];
}
